import type { RtSample } from '../../lib/types';
import type { StripRow } from './StripLog';

/** Colours of the rig activities, as on the RT Time Log legend. */
export const ACTIVITY_COLORS: Record<string, string> = {
  'Drill-rotate': '#9fd0ef',
  'Drill-slide': '#6fb1e0',
  'Wash-up': '#fde2b8',
  'Wash-down': '#f9c98a',
  'Pull-out-hole': '#f7c9c4',
  'POOH-rotate': '#f0a9a1',
  'In-slip': '#c4cacf',
  Static: '#dfe3e6',
  'Ream-up': '#b6e2ad',
  'Ream-down': '#d6f0d2',
  'Run-in-hole': '#d7d2f0',
  'RIH-rotate': '#bdb4ea',
  'Circ-only': '#f5d8ef',
  'Circ-rotate': '#eab6de',
  'Rotate-only': '#e3e8c9',
  'Out-of-hole': '#cfeeee',
};

/** A sample as a strip-log row on a time axis. */
export function timeRows(samples: RtSample[]): StripRow[] {
  return samples.map((s) => ({
    y: Date.parse(s.t),
    values: s as unknown as Record<string, number>,
    activity: s.activity,
  }));
}

export const hhmm = (ms: number) =>
  new Date(ms).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });

export function stamp(t: string | undefined) {
  if (!t) return '';
  const d = new Date(t);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${String(d.getFullYear()).slice(2)}\n${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** Grid steps for a time window: lines every few minutes, labels less often. */
export function timeGrid(spanMinutes: number) {
  const minute = 60_000;
  if (spanMinutes <= 30) return { minor: 1 * minute, major: 5 * minute };
  if (spanMinutes <= 60) return { minor: 5 * minute, major: 10 * minute };
  if (spanMinutes <= 120) return { minor: 5 * minute, major: 15 * minute };
  return { minor: 15 * minute, major: 60 * minute };
}
